import { render, staticRenderFns } from "./QuilombolasBa.vue?vue&type=template&id=3ba53343&lang=pug"
import script from "./QuilombolasBa.vue?vue&type=script&lang=js"
export * from "./QuilombolasBa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports